import React from 'react'
import { Card, Empty, Spin } from 'antd'
import { workflowService } from '@services/admin/workflowService'

export default function WorkflowWidget({ workflow }) {
  const [loading, setLoading] = React.useState(true)
  const [workflowData, setWorkflowData] = React.useState(null)

  React.useEffect(() => {
    const fetchWorkflow = async () => {
      if (!workflow?.workflow_id) {
        setLoading(false)
        return
      }

      try {
        const res = await workflowService.get(workflow.workflow_id)
        if (res.success) {
          setWorkflowData(res.data)
        }
      } catch (error) {
        console.error('Failed to fetch workflow:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchWorkflow()
  }, [workflow?.workflow_id])

  if (loading) {
    return (
      <Card title={workflow?.name || 'Loading...'} size="small">
        <div style={{ textAlign: 'center', padding: 20 }}>
          <Spin />
        </div>
      </Card>
    )
  }

  if (!workflowData?.script) {
    return (
      <Card title={workflow?.name || 'Workflow'} size="small">
        <div style={{ color: '#999', textAlign: 'center' }}>
          No script configured
        </div>
      </Card>
    )
  }

  return (
    <Card
      title={workflowData.name}
      size="small"
    >
      <Empty description="Script sandbox removed" />
    </Card>
  )
}
